<div class="flex flex-col justify-center items-center h-100" *ngIf="parcelDataLoading | async; else loaded">
  <mat-spinner diameter="50"></mat-spinner>
  <p class="mt-2">Loading data...</p>
</div>
<ng-template #loaded>
  <div class="list-wrapper" *ngIf="parcels$ | async as parcels">
    <ng-container>
      <!-- Mail list header -->
      <div class="header">
        <!-- Header left -->
        <div class="left">
          <!-- Category name -->
          <div class="category">{{ parcels?.length }} Results</div>
          <button
            class="next-button"
            mat-icon-button
            [disabled]="!parcels?.length"
            (click)="viewAsTable(parcels)"
            matTooltip="View Results as Table"
          >
            <mat-icon>table_chart</mat-icon>
          </button>
        </div>

        <!-- Loading bar -->
        <mat-progress-bar class="loading-progress-bar" *ngIf="isLoading" [mode]="'indeterminate'"></mat-progress-bar>
      </div>

      <!-- Mail list -->
      <div class="list" #parcelList>
        <!-- Mail list item loop -->
        <ng-container *ngFor="let parcel of parcels; let i = index; trackBy: trackByFn">
          <ng-container *ngIf="parcel">
            <!-- Mail list item -->
            <a class="item">
              <div class="item-content">
                <!-- Info -->
                <div class="info">
                  <!-- Sender name -->
                  <div class="name" (click)="loadParcelDetail(parcel.parcel?.id)">
                    {{ parcel.parcel?.addrLine1 }}
                  </div>
                  <button
                    class="next-button"
                    mat-icon-button
                    (click)="loadParcelDetail(parcel.parcel?.id)"
                    matTooltip="Open Details"
                  >
                    <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
                  </button>
                </div>
                <div class="owner-line">
                  <span><strong>Owner</strong>: {{ parcel.taxAssessor?.partyOwner1NameFull }}</span>
                  &nbsp;
                  <button
                    (click)="searchOwner(parcel.taxAssessor?.partyOwner1NameFull)"
                    mat-icon-button
                    matTooltip="Search By Owner"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                </div>

                <div class="owner-line">
                  <span
                    ><strong>Owner Mailing Address</strong>: {{ parcel.taxAssessor?.contactOwnerMailAddressFull }}</span
                  >
                  &nbsp;
                  <button
                    (click)="searchAddress(parcel.taxAssessor?.contactOwnerMailAddressFull)"
                    mat-icon-button
                    matTooltip="Search By Address"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                </div>

                <div class="subject">
                  <span><strong>Building SF</strong>: {{ parcel.taxAssessor?.areaBuilding | number: '1.0-0' }}</span>
                </div>
                <div class="subject">
                  <span
                    ><strong>Lot Size</strong>: {{ parcel.taxAssessor?.areaLotAcres | number: '1.0-0' }} acres /
                    {{ parcel.taxAssessor?.areaLotSf | number: '1.2-2' }} SF</span
                  >
                </div>
                <div class="subject" *ngIf="parcel.taxAssessor?.unitsCount && parcel.taxAssessor?.unitsCount > 0">
                  <span>Units: {{ parcel.taxAssessor?.unitsCount }}</span>
                </div>
                <div class="subject" *ngIf="parcel.parking_space_count && parcel.parking_space_count > 0">
                  <span
                    ><strong>Parking Ratio</strong>:
                    {{
                      parcel.taxAssessor?.areaBuilding > 0
                        ? parcel.taxAssessor?.parkingSpaceCount / parcel.taxAssessor?.areaBuilding
                        : ''
                    }}</span
                  >
                </div>
              </div>
            </a>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <ng-template #noParcels>
    <div class="no-parcels">
      <mat-icon [svgIcon]="'iconsmind:mailbox_empty'"></mat-icon>
      <h4>There are no e-mails</h4>
    </div>
  </ng-template>
</ng-template>
